<template>
  <router-view />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App'
})
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Google Sans", arial, sans-serif;
}
</style>
